import React from 'react'
import { Button } from 'primereact/button'


export type EditCardTemplateProps<T> =
  {
    label:string
    onClose?:(_:T[]) => void | Promise<unknown>
    children:React.ReactElement
    className?: string
    removeClose?: true
  } & {
    initialValue:T[]
  } & ({
    nosave?:false
    onSave:(_:T[]) => void | Promise<unknown>
  } | {
    nosave:true
    onSave?:undefined
  })

export const EditCardTemplate = <X,>(props:EditCardTemplateProps<X>) : JSX.Element => {
  const [value,setValue] = React.useState<X[]>(props.initialValue)
  const [loading,setLoading] = React.useState<boolean>(false)

  const handleChange = (newValue:X[]) => {
    setValue(newValue)
  }

  return (
    <div className={props.className||"p-2"}>
      <div className="d-flex w-100 align-items-center justify-content-between mb-4">
        <h5>{props.label}</h5>
        {props.removeClose ? <></> : <Button label={props.nosave ? 'Done' : 'Nevermind'} className="btn btn-link m-0" onClick={() => props.onClose(value)} />}
      </div>
      {
        React.cloneElement(
          props.children,
          props.initialValue === undefined ? {} : {
            'value':value,
            'onChange':handleChange
          }
        )
      }
      {props.nosave ? <></> : <Button
        type="button"
        onClick={async () => {
          setLoading(true)
          await (props.onSave && props.onSave(value))
          setLoading(false)
        }}
        loading={loading}
        className="btn btn-primary w-100 mt-3"
        label="Save"
      />}
    </div>
  )
}

export default EditCardTemplate
